/**
 * AIMixAssistantWrapper Component
 * Wrapper for AI Mix Assistant modal
 */

import React from 'react';
import { AIMixAssistant } from '../ai';
import { toast } from 'sonner';

export const AIMixAssistantWrapper = ({
  isOpen,
  onClose,
  tracks,
  projectName,
  updateTrack,
  setMasterPluginChain,
}) => {
  const handleApplySuggestion = (trackId, suggestions) => {
    // Apply AI suggestions to track
    const updates = {};
    if (suggestions.eq) {
      updates.eq = suggestions.eq;
    }
    if (suggestions.compression) {
      updates.advancedEffects = {
        ...tracks.find(t => t.id === trackId)?.advancedEffects,
        compression: { enabled: true, ...suggestions.compression }
      };
    }
    if (suggestions.gain !== undefined) {
      updates.volume = (tracks.find(t => t.id === trackId)?.volume || 0.8) * Math.pow(10, suggestions.gain / 20);
    }
    if (suggestions.pan !== undefined) {
      updates.pan = suggestions.pan;
    }
    updateTrack(trackId, updates);
  };

  const handleApplyMastering = (masteringChain) => {
    // Apply mastering chain to master bus
    setMasterPluginChain(prev => {
      const newChain = [...prev];
      if (masteringChain.eq?.enabled) {
        // Add or update EQ
      }
      if (masteringChain.compression?.enabled) {
        // Add or update compressor
      }
      return newChain;
    });
    toast.success('Mastering chain applied to master bus');
  };

  return (
    <AIMixAssistant
      isOpen={isOpen}
      onClose={onClose}
      tracks={tracks}
      projectName={projectName || 'Untitled Project'}
      onApplySuggestion={handleApplySuggestion}
      onApplyMastering={handleApplyMastering}
    />
  );
};

export default AIMixAssistantWrapper;
